import { createPersistedToggle } from "./persisted-toggle";

export const useCableLabelVisibility = createPersistedToggle("twelve-volt:show-cable-label", false);
